import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8d73785e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RoundButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RoundButton/index.vue').default,AgenciesCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/AgenciesCard/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default,EmptyEntity: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyEntity/index.vue').default})
